import { TimePeriod } from "../../../../enum/time-period.enum";

export class PlanPricingModel {
  amount: number = null;
  validityDays: number = null;
  name: string = null;
  discountAmount: number = 0;
  discountHighlightLine: string = null;
  freeMembers: number = 0;
  amountPerMember: number = null;
  timePeriod: TimePeriod = null;
  constructor() {
  }
}
